<template>
  <v-skeleton-loader
    v-if="isLoading"
    type="text"
    width="250px"
  />
  <p
    v-else
    class="date-range text-body-2"
  >
    {{ displayLabel || 'Activity During' }}
    <span>{{ currentDateToShow }}</span>
  </p>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useDatePicker } from '@/stores/filters/datePicker';
import { formatRange } from '@/helpers/date';

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();

// Stores
const datePickerStore = useDatePicker();
const {
  sortedRange,
} = storeToRefs(datePickerStore);

const currentDateToShow = computed(() => formatRange(sortedRange.value));

const displayLabel = computed(() => ({
  'executive-insights': 'Activity During',
  'demographic-survey-report': 'Applied During',
  'overall-report': 'Applied During',
  'inbound-report': 'Applied During',
  'outbound-report': 'Applied During',
  'gender-report': 'Applied During',
  'drop-off': 'Applied During',
  'pass-through': 'Applied During',
  'hiring-report': 'Resolved Offer During',
  'weekly-snapshot': 'Live During',
  'recruiting-performance': 'Activity During',
  'language-snapshot': 'Live During',
  'content-snapshot': 'Live During',
  usage: 'Activity During',
}[route.name || 'executive-insights']));
</script>

<style lang="less" scoped>
.v-skeleton-loader {
  background: transparent;

  :deep(.v-skeleton-loader__text) {
    margin: 0;
  }
}

.date-range {
  margin-left: 8px;
  color: @text-darkest;

  span {
    color: @text-brand;
  }
}
</style>
